import React, { useEffect, useContext } from "react";
import { Dialog } from "../DialogProvider";
import firebase from "../../firebase";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import MoreVertRoundedIcon from "@material-ui/icons/MoreVertRounded";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  table: {
    maxHeight: 322,
  },
  tableTitle: {
    //background: theme.palette.warning.light,
    //color: theme.palette.common.white,
  },
  tableHeader: {
    //backgroundColor: theme.palette.warning.light,
    //color: theme.palette.common.white,
    background: theme.palette.common.white,
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  loader: {
    width: "inherit",
    height: "inherit",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(12, 12),
    margin: "auto",
  },
}));

const VerifyDoctors = () => {
  const classes = useStyles();
  const { handleOpenDialog, setFormlessState } = useContext(Dialog);
  const [doctors, setDoctors] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menu = Boolean(anchorEl);
  const doctorsRef = firebase
    .database()
    .ref("users")
    .orderByChild("isVerified")
    .equalTo(false);

  useEffect(() => {
    //fetch users
    fetchDoctors();
  }, []);

  /*
  useEffect(() => {
    //not functioning properly
    const listenDoctors = doctorsRef;

    if (!loading) {
      listenDoctors.on("child_added", (data) => {
        let clonedDoctors = [...doctors];
        if (isIncluded(clonedDoctors, data.key) && !data.val().isVerified) {
          return;
        } else {
          clonedDoctors.push({ id: data.key, ...data.val() });
          setDoctors(clonedDoctors);
        }
      });
      listenDoctors.on("child_changed", (data) => {
        let clonedDoctors = [...doctors];
        if (data.val().isVerified) {
          let doctorsIndex = -1;
          clonedDoctors.forEach((data, index) => {
            if (data.id === data.key) doctorsIndex = index;
          });
          if (doctorsIndex >= 0) {
            clonedDoctors.splice(doctorsIndex, 1);
            setDoctors(clonedDoctors);
          } else {
            return;
          }
        } else if (
          !isIncluded(clonedDoctors, data.key) &&
          !data.val().isVerified
        ) {
          clonedDoctors.push({ id: data.key, ...data.val() });
          setDoctors(clonedDoctors);
        } else {
          return;
        }
      });
    }
    return () => {
      listenDoctors.off();
    };
  }, [loading]);
  

  const isIncluded = (array, key) => {
    let matchFound = null;
    array.forEach((data) => {
      if (data.id === key) {
        matchFound = true;
      } else {
        return;
      }
    });
    return matchFound;
  };
  */

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const fetchDoctors = async () => {
    let initialDoctors = [];
    const fetchedDoctors = await doctorsRef.once("value");
    if (fetchedDoctors.exists()) {
      fetchedDoctors.forEach((data) => {
        initialDoctors.push({ id: data.key, ...data.val() });
      });
    }
    setDoctors(initialDoctors);
    setLoading(false);
  };

  return loading ? (
    <div className={classes.loader}>
      <CircularProgress color="secondary" />
    </div>
  ) : (
    <div>
      <Typography component="div" className={classes.tableTitle}>
        <Box
          fontSize={28}
          display="block"
          fontWeight="fontWeightBold"
          lineHeight={1}
          p={1}
        >
          Verify Doctors
        </Box>
      </Typography>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>Name</TableCell>
              <TableCell className={classes.tableHeader}>Email</TableCell>
              <TableCell className={classes.tableHeader}>Country</TableCell>
              <TableCell className={classes.tableHeader}>Number</TableCell>
              <TableCell className={classes.tableHeader}>Specialty</TableCell>
              <TableCell className={classes.tableHeader}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {doctors.length && !loading
              ? doctors.map((data) => (
                  <TableRow key={data.id} className={classes.tableRow}>
                    <TableCell>{data.fullName}</TableCell>
                    <TableCell>{data.email}</TableCell>
                    <TableCell>{data.country}</TableCell>
                    <TableCell>{data.phoneNumber}</TableCell>
                    <TableCell>{data.specialty}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={handleOpenMenu}
                        aria-label="more"
                        aria-controls="verify-menu"
                        aria-haspopup="true"
                      >
                        <MoreVertRoundedIcon />
                      </IconButton>
                      <Menu
                        id="verify-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={menu}
                        onClose={handleCloseMenu}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          component="a"
                          href={data.certificateUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={handleCloseMenu}
                        >
                          <Typography component="span" noWrap>
                            <Box display="inline">View Certificate</Box>
                          </Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setFormlessState({ id: data.id });
                            setTimeout(() => {
                              handleCloseMenu();
                              handleOpenDialog("VERIFY_DOCTOR", "sm");
                            }, 0);
                          }}
                        >
                          <Typography component="span" noWrap>
                            <Box display="inline">Approve Doctor</Box>
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default VerifyDoctors;
